var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 19" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M8 0c2.8 0 5.1 1.8 5.1 5.2s-2.9 7.4-5.1 7.4-5.1-3.9-5.1-7.4S5.2 0 8 0z" }),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M.3 16.6c0-2.1 1.9-3.6 4.7-4.2.7 1 1.8 1.6 3 1.8 1.2-.2 2.3-.8 3-1.8 2.7.6 4.7 2 4.7 4.2.1 3.2-15.4 3.2-15.4 0z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/StatusUser.svg